export default {
	loginData:{},
	itemNum:1,
	isLogin:0,
	isOpen:0,
	isHelp:false,
	isbillAll:0,
	isLeftBill:0,
	orderName:'',
	loginNub:0,
	isNew:false,
}



// WEBPACK FOOTER //
// ./docs/store/state.js